import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstream = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 35,
			height: 35,
			rx: 1.5,
			fill: "white",
			stroke: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 3.27295,
			width: 36,
			height: .818182,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.72729,
			y: 10.6362,
			width: 24.5455,
			height: 18,
			rx: 1,
			fill: "#A8F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.375 22.9692V16.3028C15.375 16.1048 15.4429 15.9423 15.5788 15.8153C15.7147 15.6884 15.8732 15.625 16.0545 15.625C16.1111 15.625 16.1705 15.6332 16.2326 15.6496C16.2947 15.6658 16.3541 15.6903 16.4106 15.7231L21.6576 19.0634C21.7606 19.1336 21.8378 19.2178 21.8891 19.3158C21.9406 19.4139 21.9664 19.5206 21.9664 19.636C21.9664 19.7514 21.9406 19.8581 21.8891 19.9562C21.8378 20.0542 21.7606 20.1384 21.6576 20.2086L16.4106 23.5489C16.3539 23.5817 16.2944 23.6062 16.2321 23.6224C16.1698 23.6388 16.1104 23.647 16.0538 23.647C15.8724 23.647 15.7139 23.5836 15.5784 23.4567C15.4428 23.3297 15.375 23.1672 15.375 22.9692Z",
			fill: "white"
		})
	]
});
export default SvgInstream;
